import React from "react";
import { bgColor } from "../../utility/constants/colorManager";
import ResizeListner from "../../utility/ResizeListner";
import TopHeaderComponent from "../components/ui_comps/TopHeaderComponent";
import Layout from "./Layout";

function MainLayout({ children }) {
  const { width, height } = ResizeListner();
  return (
    <div
      style={{
        width: "100%",
        height,
        boxSizing: "border-box",
        padding: 0,
        margin: 0,
        display: "flex",
        overflow: "hidden",
      }}
    >
      <Layout />
      <div
        style={{
          display: "flex",
          flex: 1,
          backgroundColor: bgColor,
          overflow: "auto",
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default MainLayout;
